import { render, staticRenderFns } from "./GameIllustration.vue?vue&type=template&id=533fb2c8&scoped=true&"
import script from "./GameIllustration.vue?vue&type=script&lang=js&"
export * from "./GameIllustration.vue?vue&type=script&lang=js&"
import style0 from "./GameIllustration.vue?vue&type=style&index=0&id=533fb2c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533fb2c8",
  null
  
)

export default component.exports